import Vue from 'vue';
import ApolloClient from 'apollo-boost';
import VueApollo from 'vue-apollo';
// import VueProgressBar from 'vue-progressbar';
// import VueLoading from 'vuejs-loading-plugin';
// import Loading from '@/views/Loading.vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueApollo);

const apolloClient = new ApolloClient({
  uri: 'https://theia.informatik.hs-augsburg.de:3030/graphql',
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

// const options = {
//   color: '#323441',
//   failedColor: '#FF000E',
//   thickness: '4px',
//   transition: {
//     speed: '0.2s',
//     opacity: '0.6s',
//     termination: 300,
//   },
//   autoRevert: true,
//   location: 'left',
//   inverse: false,
// };

// Vue.use(VueProgressBar, options);
// Vue.use(VueLoading, {
//   loading: true,
//   customLoader: Loading,
//   classes: ['loading'],
// });

new Vue({
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app');
